import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authorizationHeaders: any = 'BASIC ABC TOKEN ' + (window.localStorage.getItem('TOKEN_KEY') || 'DEFAULT_HEADER');
        const authReq = req.clone({
            headers: req.headers
                .set('Authorization', authorizationHeaders)
                .set('Cache-Control', 'no-cache')
        });
        // Pass on the cloned request instead of the original request.
        return next.handle(authReq);
    }
}



// WEBPACK FOOTER //
// ./src/app/HttpInterceptor.ts